import { PropsWithChildren } from 'react'
import { Navigate } from 'react-router-dom'

import { Main } from '../../components'
import UserHeader from './components/UserHeader'
import { usePageInfo } from '../../config/queries'
import { cn } from '@/lib/utils'
import { useHasSidebar } from '../../hooks/useHasSidebar'

const UserDashboard = ({ children }: PropsWithChildren) => {
  const {
    data: { user },
  } = usePageInfo()
  const hasSidebar = useHasSidebar()

  if (user) {
    return (
      <Main title='Profile' fullWidth={true}>
        <UserHeader />

        <div className={cn('root-width my-6', hasSidebar ? 'mx-0' : '')}>
          {children}
        </div>
      </Main>
    )
  } else {
    return <Navigate to='/' />
  }
}

export default UserDashboard
